import type { RepairOption, ServiceOfferOption } from '../types';

export const optionPrice = (option: ServiceOfferOption): number | string => {
    if (option.availabilityState === 'QUOTE_ONLY' || option.price === null) return 'Sur devis';
    return option.price === 0 ? 'Sur devis' : option.price;
};

export const preferredServiceOption = (repair: RepairOption): ServiceOfferOption | null => {
    const active = (repair.serviceOptions || [])
        .filter(option => option.isActive && option.availabilityState !== 'UNAVAILABLE')
        .sort((left, right) => left.sortOrder - right.sortOrder);
    return active.find(option => option.isDefault) || active[0] || null;
};

export const applyServiceOption = (repair: RepairOption, option: ServiceOfferOption): RepairOption => ({
    ...repair,
    price: optionPrice(option),
    originalPrice: option.compareAtPrice ?? '',
    duration: option.durationOverride || repair.duration,
    description: option.customerDescription || repair.description,
    selectedServiceOptionId: option.id,
    selectedServiceOptionLabel: option.displayLabel,
    serviceOptionSnapshot: option
});

export const repairForSelection = (repair: RepairOption): RepairOption => ({
    ...repair,
    selectedServiceOptionId: undefined,
    selectedServiceOptionLabel: undefined,
    serviceOptionSnapshot: undefined
});
